import React, { useEffect, useContext, useRef } from 'react';
import { useTwilio } from '../context/TwilioContext';
import UserContext from '../context/user-context';

/**
 * TwilioInitializer Component
 * 
 * Initializes the Twilio client when user logs in.
 * This ensures the client is ready before any chat screen opens,
 * providing instant chat loading similar to mobile app.
 */
const TwilioInitializer = () => {
  const { initializeForUser, shutdown } = useTwilio();
  const ctx = useContext(UserContext);
  const staffId = ctx?.userData?.staffId;
  const initializedStaffIdRef = useRef(null);

  useEffect(() => {
    let isCancelled = false;

    if (staffId) {
      if (initializedStaffIdRef.current !== staffId) {
        Promise.resolve()
          .then(() => {
            if (isCancelled) return;
            return initializeForUser(staffId);
          })
          .then(() => {
            if (!isCancelled) {
              initializedStaffIdRef.current = staffId;
            }
          })
          .catch(() => {
            if (!isCancelled) {
              initializedStaffIdRef.current = null;
            }
          });
      }
    } else {
      initializedStaffIdRef.current = null;
      shutdown();
    }

    return () => {
      isCancelled = true;
    };
  }, [staffId]);

  // Silent component - no UI needed
  return null;
};

export default TwilioInitializer;

